import Globalize from '@sprinx/globalize';
import forLocale from '../utils/forLocale';
var localeFmt = {};
/**
 * Vrati naformatovane cislo.
 *
 * @function
 * @param {number | string} [num] Cislo k formatovani.
 * @param {number} [fractionDigits=0] Pocet desetinnych pozic. Default je 0.
 * @returns {string}
 */

var numberFormatter = function numberFormatter(num) {
  var fractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return forLocale(localeFmt, {}, function (fmt) {
    if (!fmt[fractionDigits]) {
      fmt[fractionDigits] = Globalize.numberFormatter({
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits
      });
    }

    var toFormat = typeof num === 'string' ? Number.parseFloat(num) : num;
    return typeof toFormat === 'number' && !Number.isNaN(toFormat) ? fmt[fractionDigits](toFormat) : '';
  });
};

export default numberFormatter;